import React, { useState, useRef, useEffect } from "react";
import "../App.css";

const ImageRecognition = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editData, setEditData] = useState({});
  const [formulaModal, setFormulaModal] = useState({ open: false, content: "" });
  const [steps, setSteps] = useState([
    { label: '图片已转换为base64格式', done: false },
    { label: 'AI解析中', done: false },
    { label: 'AI解析成功', done: false },
    { label: '数据解析成功', done: false }
  ]);
  const [showSteps, setShowSteps] = useState(false);
  const [recordType, setRecordType] = useState("");
  const [debugInfo, setDebugInfo] = useState("");

  const dragRef = useRef();
  const [dragOffset, setDragOffset] = useState({ x: 0, y: 0 });
  const [dragging, setDragging] = useState(false);
  const [modalPos, setModalPos] = useState({ x: 0, y: 0 });

  // 新增：多种类支持
  const [kindEditArr, setKindEditArr] = useState([]); // [{name, range}]

  // 修改量程字段解析，支持"分析仪量程"字段
  const normalizeRange = (range) => {
    if (!range) return '';
    // 如果是"0-XX"或"0~XX"格式，保持不变
    if (/^0[-~]\d+$/.test(range)) {
      return range;
    }
    // 如果是单个数字，转换为"0-XX"格式
    if (/^\d+$/.test(range)) {
      return `0-${range}`;
    }
    return range;
  };

  useEffect(() => {
    if (result?.种类) {
      const kinds = Array.isArray(result.种类) ? result.种类 : [result.种类];
      const newKindEditArr = kinds.map(kind => ({
        name: kind.name || kind.名称 || kind,
        range: normalizeRange(kind.分析仪量程 || kind.量程 || kind.range || '')
      }));
      setKindEditArr(newKindEditArr);
    }
  }, [result]);

  const handleKindEdit = (idx, key, value) => {
    setKindEditArr(arr => arr.map((k, i) => i === idx ? { ...k, [key]: value } : k));
  };

  // 新增：可编辑的种类和量程
  const [kindEdit, setKindEdit] = useState(result?.种类?.校准种类名字 || '');
  const [rangeEdit, setRangeEdit] = useState(result?.种类?.量程 || '');

  useEffect(() => {
    if (result?.种类) {
      setKindEdit(result.种类.校准种类名字 || '');
      setRangeEdit(result.种类.量程 || '');
    }
  }, [result]);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
             setPreviewUrl(URL.createObjectURL(file));
       setResult(null);
       setError("");
    }
  };

  const API_KEY = 'app-z0DbuGxzj02O4g8OU7DnB5CF';
  const API_UPLOAD_URL = 'https://ai.avon.live/v1/files/upload';
  const API_WORKFLOW_URL = 'https://ai.avon.live/v1/workflows/run';
  const USER_ID = 'test-user';

  const uploadImageAndGetId = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user', USER_ID);
    const res = await fetch(API_UPLOAD_URL, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${API_KEY}` },
      body: formData
    });
    const data = await res.json();
    return data.id;
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setError("请先选择图片");
      return;
    }
    setShowSteps(true);
    setSteps([
      { label: '图片已转换为base64格式', done: false },
      { label: 'AI解析中', done: false },
      { label: 'AI解析成功', done: false },
      { label: '数据解析成功', done: false }
    ]);
    setLoading(true);
    setError("");
    setDebugInfo("");
    try {
      // 1. 图片转base64
      setSteps(s => s.map((step, i) => i === 0 ? { ...step, done: true } : step));
      // 2. 上传图片并获取upload_file_id
      const upload_file_id = await uploadImageAndGetId(selectedFile);
      // 3. AI解析中
      setSteps(s => s.map((step, i) => i === 1 ? { ...step, done: true } : step));
      const workflowBody = {
        inputs: {
          images: [{
            transfer_method: 'local_file',
            upload_file_id,
            type: 'image'
          }]
        },
        response_mode: 'blocking',
        user: USER_ID
      };
      const response = await fetch(API_WORKFLOW_URL, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${API_KEY}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(workflowBody)
      });
      setSteps(s => s.map((step, i) => i === 2 ? { ...step, done: true } : step));
      const data = await response.json();
      // 4. 解析AI返回的text字段中的JSON
      let result = null;
      let rawText = data.data?.outputs?.text || data.data?.text || data.outputs?.text || data.text || '';
      if (rawText) {
        // 提取```json ... ```中的内容
        let match = rawText.match(/```json[\s\S]*?([\[{].*[\]}])[\s\S]*?```/);
        let jsonStr = '';
        if (match && match[1]) {
          jsonStr = match[1].trim();
        } else {
          jsonStr = rawText.replace(/^```json\s*/, '').replace(/```[\s\S]*$/, '').trim();
        }
        try {
          result = JSON.parse(jsonStr);
        } catch (e) {
          setError('AI返回内容解析失败: ' + e.message);
          setDebugInfo(rawText);
          setSteps(s => s.map((step, i) => i === 3 ? { ...step, done: false } : step));
          setLoading(false);
          return;
        }
      }
      setResult(result);
      setSteps(s => s.map((step, i) => i === 3 ? { ...step, done: true } : step));
    } catch (err) {
      setError("AI调用失败: " + err.message);
      setDebugInfo(err.stack || err.message);
    } finally {
      setLoading(false);
    }
  };

  // 添加表格样式常量
  const tableCellStyle = {
    border: '1px solid #e8e8e8',
    padding: '8px 12px',
    textAlign: 'left',
    backgroundColor: '#fafafa',
    fontSize: '14px'
  };

  // 工具函数：获取种类限值
  const getKindLimit = (kind) => {
    if (kind === '非甲烷总烃' || kind === 'NMHC') return 3;
    if (kind === '颗粒物') return 2;
    return 2.5;
  };

  // 量程字符串转数值区间
  const getRangeDiff = (rangeStr) => {
    if (typeof rangeStr !== 'string') return 0;
    if (!rangeStr.includes('-') && !rangeStr.includes('~')) return 0;
    const sep = rangeStr.includes('-') ? '-' : '~';
    const [min, max] = rangeStr.split(sep).map(s => parseFloat(s));
    return max - min;
  };

  // 工具函数：计算漂移和判断
  const calcDriftAndStatus = (last, current, range, kind) => {
    const lastNum = Number(last);
    const currentNum = Number(current);
    const diff = Number(range);
    if (isNaN(lastNum) || isNaN(currentNum) || !diff) return { drift: '', status: '' };
    const drift = ((currentNum - lastNum) / diff) * 100;
    const limit = getKindLimit(kind);
    return {
      drift: drift.toFixed(2),
      status: `${Math.abs(drift) <= limit ? '正常' : '不正常'}（限值±${limit}%）`
    };
  };

  const kindColorMap = {
    "二氧化硫": "#e3f2fd",
    "氮氧化物": "#e8f5e9",
    "氧气": "#fff3e0",
    "颗粒物": "#fce4ec",
    "非甲烷总烃": "#f3e5f5",
    "NMHC": "#f3e5f5"
  };

  const getDefaultRange = (kind) => {
    if (kind === "氧气") return "0-25";
    if (kind === "颗粒物") return "0-30";
    if (kind === "非甲烷总烃" || kind === "NMHC") return "0-120";
    return "0-100";
  };

  // 新增：通用key提取和渲染工具
  const getEntries = (obj) => {
    if (!obj || typeof obj !== 'object') return [];
    return Object.entries(obj);
  };

  // 查找key时支持多种表述，并将"校准测试值"与"校准前测试值"视为同一个
  const findKey = (obj, keywords) => {
    if (!obj) return undefined;
    const keys = Object.keys(obj);
    // 兼容"校准测试值"与"校准前测试值"
    if (keywords.includes('校准前测试值') || keywords.includes('校准测试值')) {
      const altKeys = ['校准前测试值', '校准测试值'];
      for (const alt of altKeys) {
        const found = keys.find(k => k.includes(alt));
        if (found) return found;
      }
    }
    for (const kw of keywords) {
      const found = keys.find(k => k.includes(kw));
      if (found) return found;
    }
    return undefined;
  };

  const formulaMap = {
    '量程漂移%F.S': '量程漂移%F.S = (校准测试值 - 上次校准后测试值) / 量程 × 100',
    '零点漂移%F.S': '零点漂移%F.S = (校准前测试 - 上次校准后测试值) / 量程 × 100',
    '仪器校准是否正常': '|漂移| ≤ 2，正常，否则不正常',
    // 可继续扩展
  };

  // 1. 修改getFormulaContent，使用修改后的数值
  function getFormulaContent(key, kind, type, idx, kindEditArr) {
    // 量程漂移
    if (type === '量程漂移校准' && key.includes('量程漂移') && key.includes('F.S')) {
      const last = parseFloat(getEditedValue(idx, '量程漂移校准', '上次校准后测试值', kind['量程漂移校准']?.['上次校准后测试值'] || 0));
      const current = parseFloat(getEditedValue(idx, '量程漂移校准', '校准测试值', kind['量程漂移校准']?.['校准测试值'] || 0));
      const rangeVal = getRangeDiff(kindEditArr[idx]?.range || '');
      const calc = rangeVal ? ((current - last) / rangeVal * 100).toFixed(2) : '';
      return `<b>量程漂移%F.S</b><br/>公式：量程漂移%F.S = (校准测试值 - 上次校准后测试值) / 量程 × 100<br/>计算过程：(${current} - ${last}) / ${rangeVal} × 100 = ${calc}<br/>判断依据：绝对值≤2为正常，否则不正常。`;
    }
    // 零点漂移
    if (type === '零点漂移校准' && key.includes('零点漂移') && key.includes('F.S')) {
      const last = parseFloat(getEditedValue(idx, '零点漂移校准', '上次校准后测试值', kind['零点漂移校准']?.['上次校准后测试值'] || 0));
      const current = parseFloat(getEditedValue(idx, '零点漂移校准', '校准前测试', kind['零点漂移校准']?.['校准前测试'] || 0));
      const rangeVal = getRangeDiff(kindEditArr[idx]?.range || '');
      const calc = rangeVal ? ((current - last) / rangeVal * 100).toFixed(2) : '';
      return `<b>零点漂移%F.S</b><br/>公式：零点漂移%F.S = (校准前测试 - 上次校准后测试值) / 量程 × 100<br/>计算过程：(${current} - ${last}) / ${rangeVal} × 100 = ${calc}<br/>判断依据：绝对值≤2为正常，否则不正常。`;
    }
    if (key.includes('仪器校准是否正常')) {
      const driftKey = type === '量程漂移校准'
        ? Object.keys(kind['量程漂移校准']).find(x => x.includes('量程漂移') && x.includes('F.S'))
        : Object.keys(kind['零点漂移校准']).find(x => x.includes('零点漂移') && x.includes('F.S'));
      const drift = driftKey ? parseFloat(getEditedValue(idx, type, driftKey, (kind[type]||{})[driftKey])) : 0;
      const limit = 2;
      return `<b>仪器校准是否正常</b><br/>判断依据：|漂移| ≤ 2，正常，否则不正常。<br/>实际：|${drift}| ≤ ${limit}，${Math.abs(drift) <= limit ? '正常' : '不正常'}`;
    }
    return '暂无公式说明';
  }

  // 2. 识别值可编辑，自动刷新
  const [editKinds, setEditKinds] = useState({}); // { [kindIdx]: { 校准类型: { key: value } } }

  function handleValueEdit(kindIdx, type, key, value) {
    setEditKinds(prev => {
      const next = { ...prev };
      if (!next[kindIdx]) next[kindIdx] = {};
      if (!next[kindIdx][type]) next[kindIdx][type] = {};
      next[kindIdx][type][key] = value;
      return next;
    });
  }
  function getEditedValue(kindIdx, type, key, origin) {
    return editKinds[kindIdx]?.[type]?.[key] ?? origin;
  }

  // 新增辅助函数：获取小数位数
  function getDecimalPlaces(val) {
    if (typeof val !== 'string' && typeof val !== 'number') return 0;
    const s = String(val);
    if (s.indexOf('.') === -1) return 0;
    return s.split('.')[1].length;
  }
  // 新增辅助函数：四舍五入到指定小数位
  function roundTo(val, digits) {
    const n = Number(val);
    if (isNaN(n)) return '';
    return Number(n.toFixed(digits));
  }

  return (
    <div style={{ padding: 24, maxWidth: 800, margin: "0 auto" }}>
      <h3>运维台账核验</h3>
      <div style={{ background: '#e3f2fd', borderRadius: 24, boxShadow: '0 2px 8px #e5e9f2', padding: 24, marginBottom: 24 }}>
        <div style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <div>
              <input type="file" accept="image/*" onChange={handleFileSelect} style={{ display: 'none' }} id="fileInput" />
              <label htmlFor="fileInput" style={{ cursor: 'pointer', padding: '8px 16px', background: '#1976d2', color: 'white', borderRadius: 4 }}>选择图片</label>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <button
              onClick={handleUpload}
              disabled={!selectedFile || loading}
              style={{
                padding: '8px 16px',
                backgroundColor: '#1890ff',
                color: 'white',
                border: 'none',
                borderRadius: 8,
                cursor: selectedFile && !loading ? 'pointer' : 'not-allowed',
                opacity: selectedFile && !loading ? 1 : 0.6
              }}
            >
              {loading ? '识别中...' : '开始识别'}
            </button>
            <div>
              <label htmlFor="recordType" style={{ marginRight: 8 }}>运维台账种类：</label>
              <select id="recordType" value={recordType} onChange={(e) => setRecordType(e.target.value)} style={{ padding: '8px 16px', borderRadius: 4 }}>
                <option value="">------</option>
                <option value="daily">日常巡检</option>
                <option value="calibration">零漂/量漂校准</option>
                <option value="error">示值误差</option>
              </select>
            </div>
          </div>
        </div>

        {/* 在上传图片按钮下方增加拖拽上传区域 */}
        <div style={{ marginTop: 16, marginBottom: 16 }}>
          <div
            onDrop={e => {
              e.preventDefault();
              if (e.dataTransfer.files && e.dataTransfer.files[0]) {
                setSelectedFile(e.dataTransfer.files[0]);
                setPreviewUrl(URL.createObjectURL(e.dataTransfer.files[0]));
                         setResult(null);
         setError("");
              }
            }}
            onDragOver={e => e.preventDefault()}
            style={{
              border: '2px dashed #1976d2',
              borderRadius: 12,
              padding: 32,
              textAlign: 'center',
              background: '#f7faff',
              color: '#1976d2',
              fontSize: 16,
              cursor: 'pointer',
              minHeight: 80
            }}
          >
            拖拽图片到此处上传
          </div>
        </div>

        {previewUrl && (
          <div style={{ marginBottom: 16 }}>
            <img
              src={previewUrl}
              alt="预览"
              style={{ maxWidth: '100%', maxHeight: 300, borderRadius: 8 }}
            />
          </div>
        )}

        {error && (
          <div style={{ color: 'red', marginBottom: 16 }}>
            {error}
          </div>
        )}

        {/* 调试信息显示区域 */}
        {debugInfo && (
          <div style={{ marginBottom: 16 }}>
            <details style={{ background: '#f5f5f5', padding: 12, borderRadius: 8, border: '1px solid #ddd' }}>
              <summary style={{ cursor: 'pointer', fontWeight: 'bold', color: '#666' }}>
                调试信息 (点击展开)
              </summary>
              <pre style={{ 
                whiteSpace: 'pre-wrap', 
                wordBreak: 'break-word', 
                fontSize: '12px', 
                marginTop: 8,
                background: '#fff',
                padding: 8,
                borderRadius: 4,
                border: '1px solid #ccc'
              }}>
                {debugInfo}
              </pre>
            </details>
          </div>
        )}

        {result && (
          <div style={{ background: '#fff', padding: 16, borderRadius: 8, marginTop: 16 }}>
            <h4>识别结果：</h4>
            
            {/* 校准信息表格 */}
            {result?.校准信息 && (
              <div style={{ marginBottom: 24 }}>
                <h4>校准信息</h4>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 16 }}>
                  <tbody>
                    <tr>
                      <td style={tableCellStyle}>校准日期</td>
                      <td style={tableCellStyle}>{result.校准信息.校准日期 || '-'}</td>
                      <td style={tableCellStyle}>校准开始时间</td>
                      <td style={tableCellStyle}>{result.校准信息.校准开始时间 || '-'}</td>
                    </tr>
                    <tr>
                      <td style={tableCellStyle}>校准结束时间</td>
                      <td style={tableCellStyle}>{result.校准信息.校准结束时间 || '-'}</td>
                      <td style={tableCellStyle}>校准人</td>
                      <td style={tableCellStyle}>{result.校准信息.校准人 || '-'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            {/* 其他信息表格 */}
            {result?.其他信息 && (
              <div style={{ marginBottom: 24 }}>
                <h4>其他信息</h4>
                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 16 }}>
                  <tbody>
                    <tr>
                      <td style={tableCellStyle}>企业名称</td>
                      <td style={tableCellStyle}>{result.其他信息.企业名称 || '-'}</td>
                    </tr>
                    <tr>
                      <td style={tableCellStyle}>设备规格型号</td>
                      <td style={tableCellStyle}>{result.其他信息.设备规格型号 || '-'}</td>
                    </tr>
                    <tr>
                      <td style={tableCellStyle}>安装地点</td>
                      <td style={tableCellStyle}>{result.其他信息.安装地点 || '-'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            )}
            {/* 种类信息表格（多种类支持） */}
            {result?.种类 && (
              <div style={{ marginBottom: 24 }}>
                <h4>种类信息</h4>
                {(Array.isArray(result.种类) ? result.种类 : [result.种类]).map((kind, idx) => (
                  <div key={idx} style={{ marginBottom: 24, background: '#ffecec', borderRadius: 12, padding: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 12 }}>
                      <span style={{ fontWeight: 600, fontSize: 16, marginRight: 16 }}>种类：</span>
                      <input value={kindEditArr[idx]?.name || ''} onChange={e => handleKindEdit(idx, 'name', e.target.value)} style={{ width: 120, marginRight: 24 }} />
                      <span style={{ fontWeight: 600, fontSize: 16, marginRight: 8 }}>分析仪量程：</span>
                      <input value={kindEditArr[idx]?.range || ''} onChange={e => handleKindEdit(idx, 'range', e.target.value)} style={{ width: 120 }} />
                      <span style={{ color: 'red', marginLeft: 8 }}>图片不清分析存在偏差，已自动修复</span>
                    </div>
                    {/* 零点漂移校准表格 */}
                    {kind.零点漂移校准 && (
                      <div style={{ marginBottom: 16 }}>
                        <h5>零点漂移校准</h5>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 8 }}>
                          <thead>
                            <tr>
                              <th style={tableCellStyle}>项目</th>
                              <th style={tableCellStyle}>识别值</th>
                              <th style={tableCellStyle}>理论结果</th>
                              <th style={tableCellStyle}>是否准确</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(kind.零点漂移校准).map(([k, v]) => {
                              let theory = '';
                              let isAccurate = '';
                              if (k.includes('零点漂移') && k.includes('F.S')) {
                                const last = parseFloat(getEditedValue(idx, '零点漂移校准', '上次校准后测试值', kind['零点漂移校准']?.['上次校准后测试值'] || 0));
                                const current = parseFloat(getEditedValue(idx, '零点漂移校准', '校准前测试', kind['零点漂移校准']?.['校准前测试'] || 0));
                                const rangeVal = getRangeDiff(kindEditArr[idx]?.range || '');
                                // 理论结果始终保留四位小数
                                theory = rangeVal ? ((current - last) / rangeVal * 100).toFixed(4) : '';
                                const editedValue = getEditedValue(idx, '零点漂移校准', k, v);
                                // 判断准确性：按识别值小数位数四舍五入，允许相差1个最小单位
                                const dec = getDecimalPlaces(editedValue);
                                const t = roundTo(theory, dec);
                                const e = roundTo(editedValue, dec);
                                const minUnit = Math.pow(10, -dec);
                                isAccurate = (t === e || Math.abs(t - e) === minUnit) ? '✔' : '✘';
                              } else if (k.includes('仪器校准是否正常')) {
                                const driftKey = Object.keys(kind['零点漂移校准']).find(x => x.includes('零点漂移') && x.includes('F.S'));
                                const drift = driftKey ? parseFloat(getEditedValue(idx, '零点漂移校准', driftKey, kind['零点漂移校准'][driftKey])) : 0;
                                const limit = 2;
                                theory = Math.abs(drift) <= limit ? '正常' : '不正常';
                                const editedValue = getEditedValue(idx, '零点漂移校准', k, v);
                                isAccurate = theory === editedValue ? '✔' : '✘';
                              }
                              return (
                                <tr key={k}>
                                  <td style={tableCellStyle}>{k}</td>
                                  <td style={tableCellStyle}>
                                    <input
                                      style={{ width: 70, border: '1px solid #ccc', borderRadius: 4, padding: '2px 6px', fontSize: 14 }}
                                      value={getEditedValue(idx, '零点漂移校准', k, v)}
                                      onChange={e => handleValueEdit(idx, '零点漂移校准', k, e.target.value)}
                                    />
                                  </td>
                                  <td style={tableCellStyle}>
                                    <span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                                      onClick={() => setFormulaModal({ open: true, content: getFormulaContent(k, kind, '零点漂移校准', idx, kindEditArr) })}>
                                      {theory}
                                    </span>
                                  </td>
                                  <td style={tableCellStyle}>{isAccurate}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                    {/* 量程漂移校准表格 */}
                    {kind.量程漂移校准 && (
                      <div style={{ marginBottom: 16 }}>
                        <h5>量程漂移校准</h5>
                        <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: 8 }}>
                          <thead>
                            <tr>
                              <th style={tableCellStyle}>项目</th>
                              <th style={tableCellStyle}>识别值</th>
                              <th style={tableCellStyle}>理论结果</th>
                              <th style={tableCellStyle}>是否准确</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(kind.量程漂移校准).map(([k, v]) => {
                              let theory = '';
                              let isAccurate = '';
                              if (k.includes('量程漂移') && k.includes('F.S')) {
                                const last = parseFloat(getEditedValue(idx, '量程漂移校准', '上次校准后测试值', kind['量程漂移校准']?.['上次校准后测试值'] || 0));
                                const current = parseFloat(getEditedValue(idx, '量程漂移校准', '校准测试值', kind['量程漂移校准']?.['校准测试值'] || 0));
                                const rangeVal = getRangeDiff(kindEditArr[idx]?.range || '');
                                // 理论结果始终保留四位小数
                                theory = rangeVal ? ((current - last) / rangeVal * 100).toFixed(4) : '';
                                const editedValue = getEditedValue(idx, '量程漂移校准', k, v);
                                // 判断准确性：按识别值小数位数四舍五入，允许相差1个最小单位
                                const dec = getDecimalPlaces(editedValue);
                                const t = roundTo(theory, dec);
                                const e = roundTo(editedValue, dec);
                                const minUnit = Math.pow(10, -dec);
                                isAccurate = (t === e || Math.abs(t - e) === minUnit) ? '✔' : '✘';
                              } else if (k.includes('仪器校准是否正常')) {
                                const driftKey = Object.keys(kind['量程漂移校准']).find(x => x.includes('量程漂移') && x.includes('F.S'));
                                const drift = driftKey ? parseFloat(getEditedValue(idx, '量程漂移校准', driftKey, kind['量程漂移校准'][driftKey])) : 0;
                                const limit = 2;
                                theory = Math.abs(drift) <= limit ? '正常' : '不正常';
                                const editedValue = getEditedValue(idx, '量程漂移校准', k, v);
                                isAccurate = theory === editedValue ? '✔' : '✘';
                              }
                              return (
                                <tr key={k}>
                                  <td style={tableCellStyle}>{k}</td>
                                  <td style={tableCellStyle}>
                                    <input
                                      style={{ width: 70, border: '1px solid #ccc', borderRadius: 4, padding: '2px 6px', fontSize: 14 }}
                                      value={getEditedValue(idx, '量程漂移校准', k, v)}
                                      onChange={e => handleValueEdit(idx, '量程漂移校准', k, e.target.value)}
                                    />
                                  </td>
                                  <td style={tableCellStyle}>
                                    <span style={{ color: '#1976d2', cursor: 'pointer', textDecoration: 'underline' }}
                                      onClick={() => setFormulaModal({ open: true, content: getFormulaContent(k, kind, '量程漂移校准', idx, kindEditArr) })}>
                                      {theory}
                                    </span>
                                  </td>
                                  <td style={tableCellStyle}>{isAccurate}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            )}

            {/* 原始JSON数据 */}
            <div style={{ marginTop: 24 }}>
              <h5>原始数据：</h5>
              <pre style={{ 
                whiteSpace: 'pre-wrap', 
                wordWrap: 'break-word',
                background: '#f5f5f5',
                padding: 16,
                borderRadius: 8,
                maxHeight: 400,
                overflow: 'auto'
              }}>
                {JSON.stringify(result, null, 2)}
              </pre>
            </div>
          </div>
        )}

        {/* 步骤进度显示 */}
        {showSteps && (
          <div style={{ margin: '16px 0 24px 0' }}>
            {steps.map((step, idx) => (
              <div key={idx} style={{ display: 'flex', alignItems: 'center', marginBottom: 4, color: step.done ? '#388e3c' : '#888' }}>
                {step.done ? <span style={{ color: '#4caf50', fontWeight: 'bold', fontSize: 18, marginRight: 6 }}>✔</span> : <span style={{ display: 'inline-block', width: 18, marginRight: 6 }}></span>}
                <span>{step.label}</span>
              </div>
            ))}
          </div>
        )}
      </div>
      {formulaModal.open && (
        <div style={{ position: 'fixed', left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.25)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }} onClick={() => setFormulaModal({ open: false, content: '' })}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 28, minWidth: 320, maxWidth: '90vw', boxShadow: '0 4px 24px #0002', position: 'relative' }} onClick={e => e.stopPropagation()}>
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 12 }}>公式与计算过程</div>
            <div style={{ fontSize: 15 }} dangerouslySetInnerHTML={{ __html: formulaModal.content }} />
            <span style={{ position: 'absolute', right: 16, top: 12, fontSize: 20, color: '#888', cursor: 'pointer' }} onClick={() => setFormulaModal({ open: false, content: '' })}>×</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageRecognition; 